import React, {useState} from "react";
import EditCatalogModal from "../../components/EditCatalogModal/EditCatalogModal";
import {
    CommandBar,
    IColumn,
    ICommandBarItemProps,
    Icon,
    SelectionMode,
    ShimmeredDetailsList
} from "@fluentui/react";
import {ICatalog} from "../../models/Catalog";
import {useGetCatalogsQuery} from "../../store/Api";
import {ColumnGenerator, useConditionalButtonColumn} from "../../logic/Columns/ColumnGenerator";
import useCan, {CATALOG_MODIFY} from "../../permissions/ability"
import { useUrlPanelState } from '../../hooks/useUrlState';


const CatalogManagement: React.FC = () => {
    const getCatalogs = useGetCatalogsQuery();
    /*
     * Editing an existing catalog goes through the URL (?panel=catalog&instance=<name>) so a link can
     * open it; "Add" is a transient flow with nothing to link to, so it stays local state. Catalogs
     * are keyed by name, which is what the rest of the app passes around.
     */
    const catalogPanel = useUrlPanelState('catalog');
    const [creating, setCreating] = useState(false);
    const selectedCatalog = creating
        ? undefined
        : getCatalogs.data?.find((c) => c.name === catalogPanel.instanceId);
    const modalOpen = catalogPanel.isOpen && (creating || !!selectedCatalog);

    const commands: ICommandBarItemProps[] = [
        {
            key: 'Add',
            text: 'Add',
            iconProps: { iconName: 'Add' },
            onClick: () => {
                setCreating(true);
                catalogPanel.open();
            }
        }
    ]

    const columns: IColumn[] = [
        ColumnGenerator('Name','name', 100, 300),
        ColumnGenerator('Description', 'description', 100),
        ColumnGenerator('Active', 'active', 50, 50, (c: ICatalog) => c.active
             ? <span style={{fontSize:'2em', fontWeight: 'bold'}}><Icon iconName='CheckMark' /></span> : <></>
        ),
        useConditionalButtonColumn((c: ICatalog) => {setCreating(false); catalogPanel.open(c.name);}, 'Edit', 'Edit', CATALOG_MODIFY)
    ]

    const canModify = useCan(CATALOG_MODIFY);

    return (
        <div className="main-content">
            <h1>Catalog Management</h1>
            {canModify && (
            <CommandBar items={commands} />
            )}
            <ShimmeredDetailsList items={getCatalogs.data ?? []} enableShimmer={getCatalogs.isFetching} columns={columns} selectionMode={SelectionMode.none} />
            <EditCatalogModal
                catalog={selectedCatalog}
                isOpen={modalOpen}
                isNew={selectedCatalog === undefined}
                onClose={() => {
                    setCreating(false);
                    catalogPanel.close();
                }}
            />
        </div>
    );
}

export default CatalogManagement;
